import pipe from 'lodash/fp/pipe';
import prop from 'lodash/fp/prop';

export const getNextCursor = (action) =>
  pipe(prop(prop('meta.name', action)), prop('nextCursor'));

export const getQuery = (action) =>
  pipe(prop(prop('meta.name', action)), prop('query'));
